import React from "react";
import CustomParlayBanner from "../../components/Banners/CustomParlayBanner/CustomParlayBanner";
import PreSelectedParlayCard from "../../components/PreSelectedContestCard/PreSelectedParlayCard";
import "./PreSelectedParlaysView.style.scss";
import usePreSelectedParlaysViewModel from "./usePreSelectedParlaysViewModel";
import {ParlayStatus} from "../../constants/PickXEnums";
import moment from "moment";
const PreSelectedParlaysView = () => {

    const vm = usePreSelectedParlaysViewModel();

    return <div className="PreSelectedParlaysView">
                <CustomParlayBanner/>
                <div className="cards">
                    {vm.viewData.preSelectedParlays?.map((parlay, index) => (
                        <PreSelectedParlayCard key={index} parlay={parlay} />
                    ))}
                </div>
            </div>
};

export default PreSelectedParlaysView;